var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 22.97,
    transform: "rotate(15 -105.53 137.532) scale(.56228)",
    fill: "#ffc106"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 12.4v2m-9.8.63c.76 1.32 1 1.73 1 1.73m-8.17 5.44c1.32.76 1.73 1 1.73 1M12.4 32h2m.63 9.8c1.32-.76 1.73-1 1.73-1m5.44 8.17c.76-1.32 1-1.73 1-1.73M32 51.6v-2m9.8-.63c-.76-1.32-1-1.73-1-1.73m8.17-5.44c-1.32-.76-1.73-1-1.73-1M51.6 32h-2m-.63-9.8c-1.32.76-1.73 1-1.73 1m-5.44-8.17c-.76 1.32-1 1.73-1 1.73",
    fill: "none",
    stroke: "#ffc106",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 22.926
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01D);
export default __webpack_public_path__ + "static/media/01d.e34c7f89a5fd1671c8f25ad8d09e873a.svg";
export { ForwardRef as ReactComponent };